import { useEffect, useState, ChangeEvent } from 'react';

import { adjustInputCursor } from 'helpers/adjustInputCursor';

import { Input } from '../Input';

import { formatNumber, parseNumber, isFloat } from './helpers';
import { NumberInputProps } from './types';

export const NumberInput = ({
  parse = parseNumber,
  format = formatNumber,
  checkNumber = isFloat,
  onChangeText,
  minNumber,
  maxNumber,
  ...props
}: NumberInputProps) => {
  const [value, setValue] = useState(format(props.value));

  useEffect(() => {
    if (props.value === undefined || parse(value) !== +props.value) {
      setValue(format(props.value));
    }
  }, [format, parse, props.value, value]);

  const handleChange = (
    newValue: string,
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (!checkNumber(newValue)) return;

    let value = newValue.replace('.', ',');
    const [integer, floating] = value.split(',');

    value = format(parse(integer));
    if (floating !== undefined) {
      value = `${value},${floating}`;
    }

    if (
      newValue &&
      ((maxNumber !== undefined && parse(newValue)! > maxNumber) ||
        (minNumber !== undefined && parse(newValue)! < minNumber))
    ) {
      return;
    }

    setValue(value);

    onChangeText?.(parse(newValue));
    adjustInputCursor(event, value, newValue);
  };

  return <Input {...props} value={value} onChangeText={handleChange} />;
};
